import { forwardRef, useState } from 'react';

import { colors } from '../../colors';
import { u } from '../../styles/';
import { EyeIcon, EyeSlashIcon } from '../icons';
import { Input, InputProps } from '../Input/Input';

export const PasswordInput = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
    const [visible, setVisible] = useState(false);

    return (
        <Input
            {...props}
            ref={ref}
            type={visible ? 'text' : 'password'}
            overlay={
                <button
                    type="button"
                    onClick={() => setVisible((v) => !v)}
                    aria-label={visible ? 'Hide password' : 'Show password'}
                >
                    {visible ? (
                        <EyeSlashIcon weight="fill" color={colors.bluegray[500]} size={u(2)} />
                    ) : (
                        <EyeIcon weight="fill" color={colors.bluegray[500]} size={u(2)} />
                    )}
                </button>
            }
        />
    );
});
